export const ONE_BANK_SLIP_MESSAGE = '1 boleto encontrado!'

export const COPY_TO_CLIPBOARD = 'Código copiado com sucesso!'
